export default {
  data() {
    return {
      day: 0,
      hour: 0,
      minute: 0,
      second: 0,
      timer: null,
    };
  },
  watch: {
    item2: {
      handler: function (val) {
        if (val && val.activityState === 1) {
          const { day, hour, minute, second } = this.setCountDown(
            this.item2.activityInfo.endTime
          );
          this.day = day;
          this.hour = hour;
          this.minute = minute;
          this.second = second;
          this.timer = setInterval(() => {
            const { day, hour, minute, second } = this.setCountDown(
              this.item2.activityInfo.endTime
            );
            this.day = day;
            this.hour = hour;
            this.minute = minute;
            this.second = second;
          }, 1000);
        }
      },
      deep: true,
      immediate: true,
    },
  },

  // mounted() {

  // },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    setCountDown(endTimeString) {
      let endTime = new Date(endTimeString).getTime();
      let nowTime = new Date().getTime();
      let time = endTime - nowTime;
      if (time <= 0) {
        return {
          day: "00",
          hour: "00",
          minute: "00",
          second: "00",
        };
      }
      let day = Math.floor(time / 1000 / 60 / 60 / 24);
      let hour = Math.floor((time / 1000 / 60 / 60) % 24);
      let minute = Math.floor((time / 1000 / 60) % 60);
      let second = Math.floor((time / 1000) % 60);
      if (day < 10) {
        day = "0" + day;
      }
      if (hour < 10) {
        hour = "0" + hour;
      }
      if (minute < 10) {
        minute = "0" + minute;
      }
      if (second < 10) {
        second = "0" + second;
      }
      return {
        day,
        hour,
        minute,
        second,
      };
    },
  },
};
